const goNextStepEmitt = "goNextStep";
const canGoNextStepEmitt = "canGoNextStep";
const scrollToNextStepEmitt = "scrollToNextStep";

export default {
	GO_NEXT_STEP: goNextStepEmitt,
	CAN_GO_NEXT_STEP: canGoNextStepEmitt,
	SCROLL_TO_NEXT_STEP: scrollToNextStepEmitt
}